var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "black_panel_cla" },
    [
      _c(
        "div",
        { staticClass: "header-button-bar" },
        [
          _c("zk-button-group", {
            attrs: { toolBar: true },
            on: { add: _vm.add }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("zk-tree-grid", {
        attrs: {
          items: _vm.resourceTreeData,
          expanded: false,
          columns: _vm.columns
        }
      }),
      _vm._v(" "),
      _c("add-or-update-resource", {
        attrs: {
          visible: _vm.dialogFormVisible,
          treeData: _vm.resourceTreeData,
          form: _vm.row,
          isUpdate: _vm.isUpdate
        },
        on: {
          queryUserResourceTree: _vm.queryUserResourceTree,
          dioClose: _vm.dioClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73727405", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73727405","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/resource/src/main.vue
// module id = null
// module chunks = 